'use strict';

import ngResource from 'angular-resource';

function CompanyService ($resource) {
    return $resource(
        '/api/oem/company/:id',
        { id: '@id' },
        {
            index :  { method: 'GET',  isArray: true  },
            show  :  { method: 'GET',  isArray: false },
            create:  { method: 'POST', isArray: false },
            update:  { method: 'PUT',  isArray: false },
            destroy: { method: 'DELETE',  isArray: false }
        }        
    );
}

export default angular.module('leptonApp.CompanyService', ['ngResource'])
    .service('CompanyService', ['$resource', CompanyService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/company/company.service.js